<div class="table" [ngClass]="type || ''">
  <ng-container *ngIf="rows && rows.length > 0; else noData">

    <div class="row header" [ngStyle]="getRowStyle()">
      <div class="col" *ngFor="let col of columns">{{'PAGES.ANALYTICS.TABLE.COLUMNS.' + col.name | translate}}</div>
    </div>
    <div class="row" *ngFor="let row of rows" [ngStyle]="getRowStyle()">
      <div class="col" *ngFor="let col of columns">
        <ng-container *ngIf="col.type === 'tag'">
          <span class="tag" *ngIf="canShowTag(row)">
            {{ ("PAGES.ANALYTICS.TABLE.STATUS." + (row[col.name] ? "1" : "0")) | translate}}
          </span>
        </ng-container>
        <ng-container *ngIf="col.type === 'number'">
          {{parseNumberValue(row[col.name])}}
        </ng-container>
        <ng-container *ngIf="col.type === 'text'">
          <div class="img-wrapper" *ngIf="col.name.toLowerCase() === 'sapcode'"
            [ngStyle]="{backgroundImage: getImg(row)}">
          </div>
          {{getCellValue(row[col.name])}}
          <div class="img-wrapper star" *ngIf="col.name === 'sapCode' && row.withStar"
            [matTooltip]="'PAGES.ANALYTICS.TABLE.BFS_TOOLTIP' | translate" [matTooltipClass]="'star-tooltip'"
            [ngStyle]="{backgroundImage: 'url(assets/images/placeholder_star.svg)'}">
          </div>
        </ng-container>
      </div>
    </div>

  </ng-container>
  <ng-template #noData>
    <div class="no-data">
      {{"PAGES.ANALYTICS.TABLE.NO_DATA" | translate}}
    </div>
  </ng-template>
</div>
